import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs';

interface DynamicUrls {
  URL_Seekop: string;
  URL_API: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProspectoSummaryService {

  private readonly urlParametroSistema = 'https://www.sicopweb.com/Api/Bot/getParametroDeSistema';
  private urls: DynamicUrls = {
    URL_Seekop: '',
    URL_API: ''
  };
  private isInitialized = false;

  constructor(private http: HttpClient) { }

  async loadEnvironment(idDistribuidor: string): Promise<void> {
    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('proceso', 'URL')
      .set('variable', 'PATHSeekop');

    const resp = await firstValueFrom(this.http.get<any>(this.urlParametroSistema, { params }));
    this.urls.URL_Seekop = resp?.valor || 'https://www.sicopweb.com';
    this.urls.URL_API = this.obtenerUrlApi(resp?.valor || '');
    this.isInitialized = true;

    console.log('🌍 ProspectoSummaryService - Configuración cargada:', this.urls);
  }

  private obtenerUrlApi(urlMonitor: string): string {
    if (urlMonitor.includes('backend10.aws')) {
      return 'https://backend10.aws.sicopweb.com/api/10.0.0';
    } else if (urlMonitor.includes('qa.backend')) {
      return 'https://qa.backend.aws.sicopweb.net/api/10.0.0';
    }
    return 'https://seekop10.sicopweb.net/api/10.0.0';
  }

  private ensureInitialized(): void {
    if (!this.isInitialized) {
      throw new Error('ProspectoSummaryService: El servicio no ha sido inicializado. Llama primero a loadEnvironment().');
    }
  }

  getDatosProspecto(idDistribuidor: string, idProspecto: string): Observable<any> {
    this.ensureInitialized();

    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('idProspecto', idProspecto);

    return this.http.get(`${this.urls.URL_Seekop}/Api/Bot/getDatosProspecto`, { params });
  }

  getBitacoraPrivacidad(idDistribuidor: string, idProspecto: string): Observable<any> {
    this.ensureInitialized();

    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('idProspecto', idProspecto);

    return this.http.get(`${this.urls.URL_Seekop}/SeekopAPI/ReportesWeb/filtroslaterales/getBitacoraPrivacidad`, { params });
  }

  getHistorialDemos(idDistribuidor: string, idProspecto: string): Observable<any> {
    this.ensureInitialized();

    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('idProspecto', idProspecto);

    return this.http.get(`${this.urls.URL_Seekop}/SeekopAPI/ReportesWeb/filtroslaterales/getHistorialDemos`, { params });
  }

  getHistorialVentas(idDistribuidor: string, idProspecto: string): Observable<any> {
    this.ensureInitialized();

    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('idProspecto', idProspecto);

    return this.http.get(`${this.urls.URL_Seekop}/SeekopAPI/ReportesWeb/filtroslaterales/getHistorialVentas`, { params });
  }

  getHistorialValuaciones(idDistribuidor: string, idProspecto: string): Observable<any> {
    this.ensureInitialized();

    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('idProspecto', idProspecto);

    return this.http.get(`${this.urls.URL_Seekop}/SeekopAPI/ReportesWeb/filtroslaterales/getHistorialValuaciones`, { params });
  }

  getHistorialAdjuntos(idDistribuidor: string, idProspecto: string): Observable<any> {
    this.ensureInitialized();

    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('idProspecto', idProspecto);

    return this.http.get(`${this.urls.URL_Seekop}/SeekopAPI/ReportesWeb/filtroslaterales/getHistorialDatos`, { params });
  }

  getTableroIcon(idDistribuidor: string, idEjecutivo: string, idProspecto: string, idSeguimiento: string = ''): Observable<any> {
    this.ensureInitialized();

    let params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('idEjecutivo', idEjecutivo)
      .set('idProspecto', idProspecto)
      .set('origen', 'agenda');

    if (idSeguimiento) {
      params = params.set('idSeguimiento', idSeguimiento);
    }

    return this.http.get(`https://backend10.aws.sicopweb.com/api/10.0.0/home/seguimientos-diarios/getTableroIcon`, { params });
  }

  getCanalesComunicacion(idDistribuidor: string, idEjecutivo: string, idProspecto: string): Observable<any> {
    this.ensureInitialized();

    const body = { idDistribuidor, idEjecutivo, idProspecto };
 /*    return this.http.post(`${this.urls.URL_API}/home/canales-comunicacion`, body); */
    return this.http.post(`https://backend10.aws.sicopweb.com/api/10.0.0/home/canales-comunicacion`, body);
  }

  getDominio(idDistribuidor: string): Observable<string> {
    const params = new HttpParams()
      .set('idDistribuidor', idDistribuidor)
      .set('proceso', 'URL')
      .set('variable', 'dominio');

    return this.http.get<any>(this.urlParametroSistema, { params }).pipe(
      map((resp: any) => resp?.valor || '')
    );
  }
}
